<script>
import { orderStatusMap, bankTypeList } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import { addMinutes, differenceInMinutes, differenceInDays } from 'date-fns'
import scrollToElement from '@utils/scroll-to-element'
import { authComputed } from '@state/helpers'

export default {
  components: {},
  filters: {
    orderStatusMap,
    formatDate,
  },
  props: {
    thisTimeSelectedPetInfo: {
      type: Object,
      default: () => { }
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
    petSizeId: {
      type: Number,
      default: 0,
    },
    petCategoryId: {
      type: Number,
      default: 0,
    },
    scheduleDetail: {
      type: Object,
      default: () => { }
      // required: true,
    },
    schedules: {
      type: Array,
      default: () => [],
    },
    currentService: {
      type: Object,
      default: () => { },
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    memberInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setServicesMemberLevelPrice: {
      type: Function,
      required: true
    },
    isModified: {
      type: Boolean,
      default: false,
    },
    modifyOrder: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bankTypeList,
      isMainOrder: true, // 一開始主訂單還沒建立時，很多舊的加購的區塊都不能用
      submitData: {
        // status: 2,
        // paymentMethod: '',
        addItems: [],
      },
      priceList: [],
      nextOrder: null,
      endDate: '',
      tryingToCreteOrder: false,
      tryingGetAddList: false,
    }
  },
  created() {
    this.tryToFetchPrice()
  },
  mounted() {
  },
  computed: {
    ...authComputed,
    submitRules() {
      return {
        // bankType: [{ required: this.isRequiredBankType, message: '請選擇轉帳銀行' }],
        addItems: [{ required: true, message: '請選擇服務項目', trigger: 'blur' }],
      }
    },
    hasNextOrder() {
      return this.nextOrder
    },
    filteredStatusMap() {
      // ! 已付款不能手動改成未付款
      const filteredStatus = Object.keys(orderStatusMap)
        .filter((status) => {
          switch (this.defaultValue.status) {
            case 1:
              return +status < 2
            case 2:
              //  虛擬帳戶不能手動改成已付款
              if (+status === 1 && this.defaultValue.paymentMethod === 'Vacc') return false
              return +status <= 2
            case 3:
              return +status === 0 || +status === 3
            case 4:
              return +status === 4
            case 5:
              return +status === 0 || +status === 5
            case 6:
              return +status === 6
            default:
              return false
          }
        })
        .reduce((obj, key) => {
          obj[key] = orderStatusMap[key]
          return obj
        }, {})
      return this.isEditMode ? filteredStatus : orderStatusMap
    },
    serviceEndTime() {
      const endTime = this.isModified ? this.modifyOrder.endDate : this.endDate
      return formatDate(addMinutes(endTime, this.totalMinute), 'time')
    },
    differMinute() {
      if (!this.hasNextOrder) return 10000
      const bookingEndDate = this.isEditMode ? this.defaultValue.endDate : this.endDate
      const nextBookingStartDate = this.isEditMode ? this.defaultValue.scheduleItem.nextOrder.startDate : this.nextOrder.startDate
      const differ = differenceInMinutes(nextBookingStartDate, bookingEndDate)
      return differ - this.totalMinute
    },
    selectedItem() {
      return this.priceList.filter((price) => {
        try {
          return this.submitData.addItems.includes(price.petSizes[0].prices[0].id);
        } catch (error) {
          return false; // 或者根據你的需求返回適當的值
        }
      });
    },
    selectParams() {
      return this.selectedItem.map((item) => {
        return {
          type: 'cosmetic-add',
          title: item.title,
          priceId: item.id,
          price: item.price,
          qty: 0,
        }
      })
    },
    total() {
      return this.selectedItem.reduce((total, item) => total + this.calculatePrice(item), 0);
    },
    /**
     * @description 加購共花的時間
     */
    totalMinute() {
      return this.selectedItem.reduce((cur, next) => {
        return (cur += next.serviceTime * next.qty)
      }, 0)
    },
    isHomeService() {
      return this.defaultValue.storeType === 'home'
    },
    isEmployee() {
      return !!this.currentUser.scheduleItemId
    },
    showVacc() {
      const bookingDate = new Date(formatDate(new Date(this.defaultValue.date)))
      const today = new Date(formatDate(new Date()))
      // 虛擬帳戶付款距離預約日要大於1天
      return differenceInDays(bookingDate, today) > 1
    },
    // isRequiredBankType() {
    //   return this.submitData.paymentMethod === 'Vacc'
    // },
    storeCashflowSetting() {
      return this.defaultValue.storeCashflowSetting
    },
  },
  watch: {
    currentService: {
      handler() {
        this.findNextOrder()
      },
      deep: true,
      immediate: true,
    },
    selectedItem: {
      handler(nvl) {
      },
      deep: true,
    }
  },
  methods: {
    calculatePrice(item) {
      const qty = item.qty;
      const price = item.price;
      const discount = parseInt(item.discount);

      if (discount > 0) {
        if (item.discountType === '%') {
          return qty * (price - Math.round(price * (discount / 100)));
        }
        if (item.discountType === 'fixed') {
          const discountedPrice = price - Math.round(discount);
          return qty * (discountedPrice < 0 ? 0 : discountedPrice);
        }
      }

      return qty * price;
    },
    findNextOrder() {
      if (this.isEditMode || this.isModified) {
        this.nextOrder = this.defaultValue.scheduleItem?.nextOrder || this.scheduleDetail?.nextOrder
      } else {
        const minute = this.currentService.serviceTime * 60 * 1000
        const startTime = new Date(this.scheduleDetail.date).getTime()
        this.endDate = formatDate(new Date(minute + startTime), 'dateTime')
        // 先找出startTime 比 目前startTime 大的 但是最接近的那一個
        const afterOrders = this.schedules.filter((item) => {
          return new Date(item.startDate).getTime() > startTime
        })
        if (afterOrders.length > 0) {
          this.nextOrder = afterOrders[0]
        }
      }

      // const timesArray = afterOrders.map(item => {
      //   return parseInt(new Date(item.startDate).getTime())
      // })
      // const index = timesArray.indexOf(Math.min(...timesArray))
    },
    /**
     * @description 獲取加購清單
     */
    async tryToFetchPrice() {
      this.tryingGetAddList = true
      const { productId } = this.isEditMode || this.isModified ? this.defaultValue : this.currentService
      const id = this.isEditMode ? this.defaultValue.pet.sizeId : this.petSizeId
      const { items } = await this.$store.dispatch('product/fetchAdditionalService', {
        types: ['cosmetic-add'],
        petCategoryId: this.petCategoryId || '',
        petSizeId: id,
        branchStoreId: productId,
        state: '',
        paginate: 0
      })
      let currentAddList = items.map((item) => {
        return {
          ...item,
          price: item.petSizes[0].prices[0].price,
          thisOrderServiceId: item.petSizes[0].prices[0].id,
          serviceTime: item.petSizes[0].serviceTime,
          qty: 1,
          discount: null,
          discountType: null
        }
      })
      if (this.memberInfo.level) {
        const { servicePrices } = this.memberInfo.level
        currentAddList = this.setServicesMemberLevelPrice(currentAddList, servicePrices, 'thisOrderServiceId')
      }
      this.priceList = currentAddList
      this.tryingGetAddList = false
    },
    /**
     * @description 加入訂單
     */
    async onClickAdd() {
      await this.$refs.form.validate()
      this.$emit('submit', [...this.selectedItem])
      this.$emit('close')
    },
    addCount(item) {
      item.qty = item.qty + 1
    },
    decreaseCount(item) {
      if (item.qty === 1) {
        return
      }
      item.qty = item.qty - 1
    }
  },
}
</script>

<template>
  <div :class="$style['create-addition']">
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top"
      class="el-form-item--normal-margin el-form-item--white-bg">
      <template>
        <div class="header">
          <div>目前排程</div>
          <div>美容師：{{ isEditMode ? defaultValue.scheduleItem.name : scheduleDetail.name }}</div>
        </div>

        <div class="schedule-group-wrap">
          <div class="schedule">
            <div class="text-secondary fw-medium">本服務(含緩衝)時間</div>
            <div class="date">
              <span class="today">今天</span><br />
              <span class="time Jost">
                <span v-if="isEditMode">{{ defaultValue.time }}</span>
                <span v-else-if="isModified">{{ modifyOrder.time }}</span>
                <span v-else>{{ scheduleDetail.date | formatDate('time') }}</span>－


                <span :style="`color:${totalMinute === 0 ? '' : differMinute > 0 ? '#C79484' : '#E35D5D'};`"><span
                    class="text-primary">
                    <span v-if="isEditMode">{{ defaultValue.endDate | formatDate('time') }} </span>
                    <span v-else>{{ serviceEndTime }}</span>


                  </span></span></span>
            </div>
            <div class="service">
              <span v-if="isEditMode || isModified" class="title">{{ defaultValue.productName }} {{ defaultValue.params[0].title
              }}</span>
              <span v-else class="title">{{ currentService.storeTitle }} {{ currentService.title }}</span>
            </div>
          </div>
          <div class="schedule">
            <BaseIcon name="angle-double-right" :icon-style="'fal'"></BaseIcon>
            <div class="text-secondary fw-medium">下個服務開始時間</div>
            <template v-if="hasNextOrder">
              <div class="date">
                <span class="today">今天</span><br />
                <span class="time Jost">{{ nextOrder.startDate | formatDate('time') }}</span>
              </div>
              <div class="service">
                <span class="title">{{ nextOrder.productTitle }} {{ nextOrder.priceTitle }}</span>
              </div>
            </template>
            <div v-else class="date">
              <span class="today vs-hide">今天</span><br />
              <span class="no-booking">暫無預約</span>
            </div>
          </div>
        </div>
        <div class="alert Jost" :class="{ danger: differMinute <= 0 }">本次加購時間 <span class="text-primary Jost">{{
          totalMinute }}</span> 分鐘
          <span v-if="hasNextOrder">
            <span v-if="differMinute > 0">
              ，空檔時間剩餘 <span class="text-primary Jost">{{ differMinute }}</span> 分鐘
            </span>
            <span v-else> ，已與下個預約重疊 </span>
          </span>
        </div>
      </template>
      <el-form-item label="選擇加購項目" :class="$style.addItemformItem">
        <div v-loading="tryingGetAddList" element-loading-text="取得加購中..." :class="$style.addItems">
          <div class="wrap">
            <div v-for="(item, index) in priceList" :key="index" class="item">
              <el-checkbox-group v-model="submitData.addItems">
                <el-checkbox :label="item.petSizes[0].prices[0].id" border>
                  {{ index + 1 }}
                </el-checkbox>
              </el-checkbox-group>
              <div class="addItemDisplay">
                <div class="item__addItemTitle">
                  <p>{{ item.title }}</p>
                  <template v-if="item['discount'] !== null && item['discount'] > 0">
                    <div class="item__addItemTitle__memberDisplay">
                      <p class="text-primary Jost whiteSpaceNoWrap">會員價：NT${{ item.levelPrice }}
                        <span class="line-through-price">NT ${{ item.price }}</span>
                        <span class="minute">/{{ item.serviceTime }}分鐘</span>
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <p class="whiteSpaceNoWrap">NT ${{ item.price }}/{{ item.serviceTime }}分鐘</p>
                  </template>
                </div>
                <div class="item__addItemCount">
                  <div @click.stop="decreaseCount(item)">-</div>
                  <div>{{ item.qty }}</div>
                  <div @click.stop="addCount(item)">+</div>
                </div>
              </div>
            </div>
          </div>
          <div class="total Jost ">
            <div class="fw-regular">加購總計</div>
            <div class="text-primary">${{ total }}，共 {{ totalMinute }} 分鐘</div>
          </div>
        </div>
        <div :class="$style['addItemformItem__petName']">
          {{ $t('reserve.CLIENT') }}：{{ thisTimeSelectedPetInfo.name || '' }}
        </div>
      </el-form-item>
    </el-form>
    <el-row :gutter="20" class="footer">
      <el-col :span="24" :xs="24">
        <el-button class="is-round is-fullwidth" type="primary" @click="onClickAdd">加入訂單</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.create-addition {
  :global {
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .whiteSpaceNoWrap {
      white-space: nowrap;
    }

    .addItemDisplay {
      display: flex;
      flex-direction: row;
      flex-grow: 1;

      @media screen and (max-width: 1250px) {
        flex-direction: column;
        padding: 10px;
      }
    }

    .vs-hide {
      visibility: hidden;
    }

    .schedule-group-wrap {
      display: flex;
      padding: 24px 22px;
      background-color: white;
      border: 1px solid $color-border-base;

      .schedule {
        position: relative;
        flex: 1;

        @include max-md {
          font-size: 12px;
          font-weight: 400 !important;
        }

        svg {
          position: absolute;
          left: -40px;
          top: 62px;
          color: #c6c6ba;
          font-size: 27px;


          @include touch {
            top: 77px;
            display: none;
          }
        }

        &+.schedule {
          margin-left: 50px;

          @include touch {
            margin-left: 30px;
          }
        }

        >div:first-of-type {
          // color: #726f65;
          margin-bottom: 16px;
          letter-spacing: 0.15em;
        }

        .date {
          margin-bottom: 15px;

          .today {
            display: inline-block;
            font-size: 12px;
            letter-spacing: 1.2px;
            margin-bottom: 10px;
          }

          .time {
            font-size: 20px;
            color: $color-primary-light;
            letter-spacing: 2px;
            line-height: 18px;
            font-weight: 500;

            @include max-md {
              font-size: 16px;
            }
          }
        }

        .service {
          .title {
            display: inline-block;
            margin-bottom: 5px;
            letter-spacing: 1.4px;
          }

          .size {
            font-size: 12px;
            color: #726f65;
          }
        }

        .no-booking {
          color: #d0d0d0;
          letter-spacing: 1.4px;
        }
      }
    }

    .alert {
      margin-top: 15px;
      margin-bottom: 20px;
      padding: 15px 20px;
      letter-spacing: 1.4px;
      // color: #41695b;
      background-color: #F2F2F2;

      &.danger {
        color: $color-state-danger;
        background-color: #e35d5d17;
      }
    }

    @include touch {
      .el-input__inner {
        background-color: white;
        border-color: $color-border-base;
        border-radius: 8px;
      }

      .footer {
        display: flex;
        flex-direction: column-reverse;

        .el-col+.el-col {
          margin-bottom: 10px;
        }
      }
    }
  }
}

.addItems {
  border: 1px solid $color-border-base;
  border-radius: 8px;
  overflow: hidden;

  :global {
    .wrap {
      // max-height: calc(100vh - 570px);
      min-height: 195px;
      height: calc(100vh - 570px);
      overflow: auto;
      background-color: white;

      @include max-md {
        height: calc(100vh - 370px);
      }

      &::-webkit-scrollbar {
        display: block;
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d8d8d8;
      }

      &::-webkit-scrollbar-track {
        background: #f5f5f5ed;
      }

      .item {
        border-bottom: 1px solid $color-border-base;
        display: flex;
        padding-top: 2px;
        padding-bottom: 2px;
        height: 65px !important;
        width: auto;

        @media screen and (max-width: 1250px) {
          height: 130px !important;
        }

        .el-checkbox {
          width: 100%;
          display: flex;
          align-items: center;
          border: none;
          padding: 10px 1.25rem;
          height: 100%;
          color: $color-secondary;
          font-weight: 400;

          .el-checkbox__label {
            display: flex;
            justify-content: space-between;
            flex: 2;
            letter-spacing: 1.4px;
            align-items: center;
            color: $color-secondary;

            .name {
              display: inline-block;
              min-width: 90px;
            }

            br {
              display: none;
            }

            @include touch {
              br {
                display: inherit;
              }

              .size {
                color: #d0d0d0;
              }
            }

            .size {
              font-size: 12px;
            }
          }

          .el-checkbox__inner {
            width: 14px;
            height: 14px;

            &::after {
              height: 6px;
              width: 4px;
              border-width: 2px;
            }
          }
        }

        &__addItemTitle {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          min-width: 275px;

          p {
            margin-top: 2px;
            margin-bottom: 2px;
            height: 25px;
            display: flex;
            align-items: center;
          }


          &__memberDisplay {
            display: flex;
            align-items: flex-end;

            :global {
              .line-through-price {
                margin-left: 5px;
                text-decoration: line-through;
              }

              .minute {
                color: #726F65;
                margin-left: 5px;
              }
            }
          }
        }

        &__addItemCount {
          display: flex;
          align-items: center;
          // flex-grow: 1;
          justify-content: flex-end;
          padding-right: 20px;
          padding-left: 20px;

          @media screen and (max-width: 1250px) {
            justify-content: flex-start;
            padding-left: 0;
          }

          >div:nth-child(2n+1) {
            width: 44px;
            height: 44px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid $color-primary;
            border-radius: $border-radius;
            color: $color-primary;
          }

          >div:nth-child(2n+1):hover {
            cursor: pointer;
          }

          >div:nth-child(2) {
            margin-left: 24px;
            margin-right: 24px;
            width: 20px;
            display: flex;
            justify-content: center;
          }
        }

        @media screen and (max-width: 450px) {
          height: 80px;
        }

      }
    }

    .total {
      display: flex;
      justify-content: space-between;
      padding: 20px 25px;
      // color: #41695b;
      background-color: #F2F2F2;
      line-height: 1;
      letter-spacing: 0.15em;
      font-weight: 500;
      font-size: 1.125rem;
      border-top: 1px solid $color-border-base;
      color: $color-secondary;
    }
  }
}

.payment-methods {
  :global {
    .el-radio {
      margin: 5px !important;
    }

    .vacc-disabled {
      margin-bottom: 20px;

      &::after {
        content: '(服務前一日不提供)';
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        color: #c2c6ce;
      }
    }
  }
}

.addItemformItem {
  &__petName {
    position: absolute;
    top: -40px;
    right: 0
  }
}
</style>
